import React from "react";
import { Grid, Paper, Box } from "@mui/material";
import ActivityOverView from "./ActivityOverView/ActivityOverView";

const Index = () => {
  return (
    <Box sx={{ width: "100%", backgroundColor: "#f5f5f5", p: 3 }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper
            sx={{
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <ActivityOverView />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Index;
